import React, { useEffect, useState } from "react";
import GlobalWrapper from "../../components/Wrapper/GlobalWrapper";
import { Box, Card, Chip, Stack } from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import GlobalDatagrid from "../../components/mui/DataGrid/GlobalDatagrid";
import { useDispatch, useSelector } from "react-redux";
import dayjs from "dayjs";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { Assessment_Course_Head } from "../../components/datagrid/assessment/AssessmentCourseTableHead";
import GlobalMultiSelect from "../../components/mui/GlobalMultiSelect";
import { useLocation, useNavigate } from "react-router-dom";
import { Assessment_Grade_Head } from "../../components/datagrid/assessment/AssessmentGradeTable";
import { getGradeWiseDetails } from "../../redux/features/assessmentDashboardSlice";
import { getOgaLists } from "../../redux/features/OgdDashboard";
import FromAndToDatePicker from "../../components/mui/FromAndToDatePicker";
import Search from "../../components/Search/Search";

const AssessmentGrideWise = () => {
  const userProfile = JSON.parse(localStorage.getItem("cred")).profile;
  const location = useLocation();
  const dispatch = useDispatch();
  const navigate = useNavigate("");
  const searchParams = new URLSearchParams(location.search);
  const userID = searchParams.get("userID");
  const courseName = searchParams.get("course_name");
  const fromdate = searchParams.get("fromDate");
  const todate = searchParams.get("toDate");
  const [fromDate, setFromDate] = useState(
    fromdate || dayjs().startOf("month").format("YYYY-MM-DD")
  );
  const [toDate, setToDate] = useState(
    todate || dayjs().endOf("month").format("YYYY-MM-DD")
  );
  const matrixName = searchParams.get("matrix_name");
  const gradeName = searchParams.get("grade_name");

  const { paginationData } = useSelector((state) => state.globalDataGrid);
  const { gridSize, pageNum, rowData, openAnchor, search } = paginationData;
  const [oga, setOga] = useState("");
  const { gradeLeadData, loading } = useSelector(
    (state) => state.assessmentDashboard
  );

  useEffect(() => {
    dispatch(
      getGradeWiseDetails({
        fromDate: dayjs(fromDate).format("YYYY-MM-DD"),
        toDate: dayjs(toDate).format("YYYY-MM-DD"),
        userID: userID,
        course_name: courseName,
        matrix_name: matrixName,
        grade_name: gradeName,
        dateFilter: 1,
        page: pageNum,
        limit: gridSize,
        search: search,
      })
    );
  }, [fromDate, toDate, pageNum, gridSize, search]);

  const ogaList = [
    { userId: 1, name: "Fayis" },
    { userId: 2, name: "Test oga 1" },
  ];

  return (
    <GlobalWrapper title={"Grade Report"}>
      <Box
        sx={{
          display: "flex",
          gap: 1,
          padding: 2,
          justifyContent: "flex-start",
        }}
      >
        <Box>
          <FromAndToDatePicker
            disabled={false}
            fromDate={fromDate}
            toDate={toDate}
            setFromDate={setFromDate}
            setToDate={setToDate}
          />
        </Box>
      </Box>
      <Box sx={{ width: "100%", padding: 0 }}>
        <GlobalDatagrid
          tableHead={Assessment_Grade_Head}
          rows={gradeLeadData.data}
          meta={gradeLeadData?.meta?.totalRecords || 0}
          rowUniqueId="lead_id"
          loading={loading}
          rowClick={false}
        />
      </Box>
    </GlobalWrapper>
  );
};

export default AssessmentGrideWise;
